import { ApiProblemError } from '@taler/api-client'

/** The server's own detail message when there is one, so a validation reason survives to the UI. */
export function problemDetail(error: Error | null): string | undefined {
  return error instanceof ApiProblemError ? error.problem.detail : undefined
}

/** The error's stable code, when it is one - lets a screen react to a specific outcome
 * (e.g. `receipt.total_mismatch`) rather than pattern-matching on prose. */
export function problemCode(error: Error | null): string | undefined {
  return error instanceof ApiProblemError ? error.problem.code : undefined
}

/** A 409 from the idempotency filter is a pending state, not a failure: the same corrected
 * resubmission gets a new key and replays cleanly, so the fix is to retry, not to give up. */
export function isIdempotencyPending(error: Error | null): boolean {
  return error instanceof ApiProblemError && error.code === 'idempotency.in_flight'
}
